<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="6" lg="3" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <template v-if="permisosAcademicosSede || permisosAcademicosNacional">
              <v-btn
                class="mx-1"
                color="primary"
                title="Registrar Solicitud Inscripción"
                small
                @click="$refs.modalFormularioInscripcionRef.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Registrar
              </v-btn>

              <v-btn
                class="mx-1"
                title="Editar"
                small
                :disabled="item == null || item.estado != estadosSolicitudesInscripciones.PENDIENTE"
                @click="$refs.modalFormularioInscripcionRef.abrir(accionesCrud.EDITAR, item)">
                <v-icon>mdi-pencil</v-icon>

                Editar
              </v-btn>

              <v-btn
                small
                class="mx-1"
                :disabled="
                  item == null ||
                  (getFiltrarPorSede && item.sedeId != $store?.state?.cargo_sede?.sede?.id) ||
                  item.estado != estadosSolicitudesInscripciones.PENDIENTE
                "
                title="Eliminar"
                @click="
                  () =>
                    confirmacionAccion(
                      accionesAConfirmar.ELIMINAR,
                      nombreItem,
                      `con N° de Solicitud ${item.numeroSolicitud} del Solicitante ${item.nombreSolicitante}`,
                    )
                ">
                <v-icon>mdi-close</v-icon>

                Eliminar
              </v-btn>
            </template>

            <v-btn
              class="mx-1"
              title="Ver"
              small
              :disabled="item == null"
              @click="$refs.modalMostrarSolicitudInscripcionRef.abrir(item)">
              <v-icon>mdi-eye</v-icon>

              Ver
            </v-btn>

            <v-btn
              class="mx-1"
              title="Ver PDF"
              small
              :disabled="item == null || cargandoPdf"
              :loading="cargandoPdf"
              @click="obtenerReporteSolicitudInscripcion(item.id)">
              <v-icon>mdi-file-pdf</v-icon>

              Ver PDF
            </v-btn>

            <v-btn
              class="mx-1"
              title="Ver Todos PDF"
              small
              :disabled="items.length === 0 || cargandoTodosPdf"
              :loading="cargandoTodosPdf"
              @click="obtenerReporteSolicitudesInscripciones">
              <v-icon>mdi-file-pdf</v-icon>

              Ver Todos PDF
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12" class="px-2">
            <ListadoSolicitudesInscripciones
              ref="listadoRef"
              :items="items"
              :cargando="cargando"
              @selectItem="selectItem" />
          </v-col>
        </v-row>

        <ModalFormularioSolicitudInscripcion
          ref="modalFormularioInscripcionRef"
          :nombreRecurso="nombreItem"
          :programaId="form?.id"
          :programaUniversidadId="form?.programaUniversidadId"
          :universidadId="form?.universidadId"
          @actualizarListado="listar" />

        <ModalMostrarSolicitudInscripcion ref="modalMostrarSolicitudInscripcionRef" />

        <ModalVerPdf ref="modalVerPdfRef" />

        <ConfirmacionAccion
          ref="confirmacionRef"
          :titulo="confirmacion.titulo"
          :mensaje="confirmacion.mensaje"
          :realizandoAccion="confirmacion.realizandoAccion"
          @aceptar="confirmacion.fnAceptar" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoSolicitudesInscripciones from './ListadoSolicitudesInscripciones.vue';
import ModalFormularioSolicitudInscripcion from './ModalFormularioSolicitudInscripcion.vue';
import { mapGetters } from 'vuex';
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';
import SolicitudInscripcionService from '../services/solicitud-inscripcion.service';
import ModalMostrarSolicitudInscripcion from './ModalMostrarSolicitudInscripcion.vue';
import ModalVerPdf from './ModalVerPdf.vue';
import SolicitudInscripcionReporteService from '../services/solicitud-inscripcion-reporte.service';
import ListadoItem from './ListadoItem.vue';
import { ESTADOS_SOLICITUDES_INSCRIPCIONES } from '../utils/constantes';
import { imprimirModulo, obtenerModuloMasAlto } from '../utils/funciones';

export default {
  name: 'ModalSolicitudesInscripciones',
  mixins: [programaUniversidadMixin],
  components: {
    ListadoSolicitudesInscripciones,
    ModalFormularioSolicitudInscripcion,
    ModalMostrarSolicitudInscripcion,
    ModalVerPdf,
    ListadoItem,
  },
  data() {
    return {
      nombreItem: 'Solicitud Inscripción',
      detallesSolicitudesInscripciones: [],
      cargandoPdf: false,
      cargandoTodosPdf: false,
      estadosSolicitudesInscripciones: ESTADOS_SOLICITUDES_INSCRIPCIONES,
    };
  },
  computed: {
    ...mapGetters({
      getFiltrarPorSede: 'pago/getFiltrarPorSede',
      permisosAcademicosSede: 'pago/permisosAcademicosSede',
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
    }),
    listado() {
      return [
        { nombre: 'Código', valor: this.form.codigo },
        { nombre: 'Sede', valor: this.form.sede?.nombre },
        {
          nombre: 'Gestión / Versión / Grupo',
          valor: `${this.form.gestion} / ${this.form.version} / ${this.form.grupo}`,
        },
        { nombre: 'Nombre Compuesto', valor: this.form.nombreCompuesto },
        {
          nombre: 'Módulo Actual',
          valor: this.programaModuloTexto,
        },
        { nombre: 'Código Programa Universidad', valor: this.form.programaUniversidad?.codigo || '-' },
        { nombre: 'Programa Universidad', valor: this.form.programaUniversidad?.programaNombre || '-' },
        { nombre: 'Universidad', valor: this.form.universidad?.nombre },
      ];
    },
    programaModuloMasAlto() {
      const programasModulos = this.form?.programasModulos;

      return obtenerModuloMasAlto(programasModulos);
    },
    programaModuloTexto() {
      return imprimirModulo(this.programaModuloMasAlto);
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        sedeId: null,
        sede: null,
        gestion: null,
        nombreCompuesto: null,
        postgradoId: null,
        postgrado: null,
        programaUniversidadId: null,
        programaUniversidad: null,
        nombreCorto: null,
        version: null,
        grupo: null,
        universidadId: null,
        universidad: null,
        programasModulos: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        sedeId: data.sedeId,
        sede: data.sede,
        gestion: data.gestion,
        nombreCompuesto: data.nombreCompuesto,
        postgradoId: data.postgradoId,
        postgrado: data.postgrado,
        programaUniversidadId: data.programaUniversidadId,
        programaUniversidad: data.programaUniversidad,
        nombreCorto: data.nombreCorto,
        version: data.version,
        grupo: data.grupo,
        universidadId: data.universidadId,
        universidad: data.universidad,
        programasModulos: data.programasModulos || [],
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      const params = {
        programaId: this.form.id,
        sedeId: this.getFiltrarPorSede ? this.$store?.state?.cargo_sede?.sede?.id : null,
      };

      this.obtenerDatosConNotificacion(SolicitudInscripcionService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await SolicitudInscripcionService.remove(this.item.id);
      }

      return response;
    },
    async obtenerReporteSolicitudInscripcion(solicitudId) {
      const params = {
        formato: 'base64',
      };

      this.cargandoPdf = true;

      try {
        const { data } = await SolicitudInscripcionReporteService.findOne(solicitudId, { params });
        const { datos, mensaje } = data;
        const base64 = datos;
        const pdf = `data:application/pdf;base64,${base64}`;

        this.$refs.modalVerPdfRef.abrir(pdf);
        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Reporte generado exitosamente',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.base64 = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener el reporte',
          type: 'error',
        });
      } finally {
        this.cargandoPdf = false;
      }
    },
    async obtenerReporteSolicitudesInscripciones() {
      const params = {
        formato: 'base64',
        sedeId: this.getFiltrarPorSede ? this.$store?.state?.cargo_sede?.sede?.id : null,
        programaId: this.form.id,
      };
      this.cargandoTodosPdf = true;

      try {
        const { data } = await SolicitudInscripcionReporteService.findAll({
          params,
        });
        const { datos, mensaje } = data;
        const base64 = datos;
        const pdf = `data:application/pdf;base64,${base64}`;

        this.$refs.modalVerPdfRef.abrir(pdf);
        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Reporte generado exitosamente',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.base64 = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener el reporte',
          type: 'error',
        });
      } finally {
        this.cargandoTodosPdf = false;
      }
    },
  },
};
</script>